module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-2021-3.fee47ed9.jpg";